<h1>JavaScript als Element-Aktion</h1>
<section class="article">
    <article>
        <div class="text">
            <p>
                Version 2.3 ergänzt die Möglichkeiten, auf Benutzereingaben zu reagieren,
                um den Aufruf von eigenen JavaScripten. Das ermöglicht insbesondere die
                Kommunikation mit externen Webdiensten.
            </p>
            <img src="assets/script_editor.png" />
        </div>
    </article>
</section>
